import dayjs from "dayjs";
import React, { useState } from "react";
import Modal from "../../../components/ui/Modal/Modal";

const QRTable = (props) => {
  const {
    dataQr,
    handleFullShipping,
    closeModal,
    confirmModal = "불량접수 배송은 전체 배송으로만 진행됩니다.",
    selectedItem,
    onSelectLot,
    onCloseQrTableModal,
    handlePartialShipping,
    totalQnt,
    isExchanged,
  } = props;
  const [showPartialDescription, setShowPartialDescription] = useState(false);
  const handlePartial = () => {
    handlePartialShipping();
  };

  return (
    <div className="-mb-2">
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">QR 스캔 결과</h1>
        <div className="flex items-center">
          <p className="mr-5">※ 출고 처리할 재고를 선택해 주세요.</p>
          <button
            onClick={onCloseQrTableModal}
            className="border mr-2 px-8 py-1 border-button-grey rounded-[4px]"
          >
            취소
          </button>
          <Modal
            hasCancel={isExchanged ? true : false}
            hasSubmit={isExchanged ? true : false}
            triggerClose={closeModal}
            onSubmit={handleFullShipping}
            description={
              isExchanged ? (
                <div className="mb-3 px-2">
                  <span>교환배송은 전체 배송으로만 진행됩니다.</span>
                </div>
              ) : !showPartialDescription ? (
                <div className="-mb-3 px-2">
                  배송 출고 방법을 선택해주세요.
                  <br />
                  1. 전체 배송 : 모두 배송 처리
                  <br />
                  2. 부분 배송 : 재고가 부족한 경우, 총 2회차까지 진행 가능
                  <div className="flex mt-3 justify-end">
                    <button
                      onClick={handleFullShipping}
                      className="border mr-2 border-primary-blue bg-primary-blue text-white rounded-[4px] px-4 py-1"
                    >
                      전체 배송
                    </button>
                    {!isExchanged && (
                      <button
                        onClick={handlePartial}
                        className="border border-primary-blue bg-primary-blue text-white rounded-[4px] px-4 py-1"
                      >
                        부분 배송
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="-mb-3">
                  {confirmModal}
                  <div className="mt-4 flex justify-end">
                    <button
                      onClick={handlePartial}
                      className="border py-1 w-20 rounded-[4px] mr-2 border-black text-black"
                    >
                      취소
                    </button>
                    <button
                      onClick={handleFullShipping}
                      className="border w-20 rounded-[4px] border-primary-blue text-white bg-primary-blue"
                    >
                      확인
                    </button>
                  </div>
                </div>
              )
            }
          >
            <button className="border mr-5 px-6 py-1 border-primary-blue bg-primary-blue text-white rounded-[4px]">
              선택 완료
            </button>
          </Modal>
        </div>
      </div>
      <div className="px-5 pb-2">
        <div className="border mt-4 py-2 px-4 text-white border-primary-blue bg-primary-blue">
          재고정보 (현재 재고수량 : {totalQnt}개)
        </div>
        <table className="min-w-full">
          <thead>
            <tr className="bg-input-grey font-bold text-center">
              <td className="border w-14 border-disable-grey py-2.5">번호</td>
              <td className="border border-disable-grey w-28 py-2.5">LOT</td>
              <td className="border w-44 border-disable-grey py-2.5">QR번호</td>
              <td className="border border-disable-grey py-2.5">제조일자</td>
              <td className="border border-disable-grey py-2.5">유효일자</td>
              <td className="border border-disable-grey py-2.5">재고수량</td>
              <td className="border border-disable-grey py-2.5">선택</td>
            </tr>
          </thead>
          <tbody>
            {dataQr
              .sort((a, b) => b.id - a.id)
              .map((item, index) => (
                <tr className="text-center" key={item.id}>
                  <td className="border py-2 border-disable-grey">
                    {dataQr?.length - index}
                  </td>
                  <td className="border w-20 py-2 border-disable-grey">
                    {item.productLotInfo.lotNo}
                  </td>
                  <td className="border py-2 border-disable-grey">
                    {item.qrNo}
                  </td>
                  <td className="border py-2 w-24 border-disable-grey">
                    {dayjs(item.productLotInfo.manufacDate).format(
                      "YYYY-MM-DD"
                    )}
                  </td>
                  <td className="border py-2 w-24 border-disable-grey">
                    {dayjs(item.productLotInfo.expireDate).format("YYYY-MM-DD")}
                  </td>
                  <td className="border py-2 w-20 border-disable-grey">
                    {item.qnt}
                  </td>
                  <td className="border w-28 py-2 px-2 border-disable-grey">
                    <div className="flex justify-center">
                      <button
                        onClick={() => onSelectLot(item?.id)}
                        disabled={item.qnt === 0}
                        className={`${
                          item.qnt === 0
                            ? "text-disable-black border border-input-grey bg-input-grey"
                            : selectedItem.some(
                                (e) => e.productLotId === item.id
                              )
                            ? "bg-backdrop-blue border border-backdrop-blue text-white"
                            : "text-backdrop-blue border border-backdrop-blue"
                        }  px-2 py-1 rounded-[4px]`}
                      >
                        {item.inventoryQty === 0 ? "출고 불가" : "출고 선택"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QRTable;
